import classNames from 'classnames';
import React from 'react';
import {
	IChatCommandWidgetHtmlData,
	IChatCommandWidgetMessage,
} from '@enuan/chat__utils';
import { Html } from '../../message/content';
import { useMessageContext } from '../../message/message.context';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { Message } from '../../UI/Message/Message';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

type HtmlMessageProps = { className?: string } & IOptionalMessageProps;

/**
 * Wraps HTML widget command messages in the standard chat message chrome.
 *
 * The component is dedicated to `show_widget` HTML commands so the raw HTML
 * renderer stays isolated from the plain text message flow.
 *
 * @param props - Optional message chrome props and root class name.
 * @param ref - Ref forwarded to the message article element.
 * @returns Standard HTML command message layout.
 */
export const HtmlMessage = React.forwardRef<HTMLElement, HtmlMessageProps>(
	function HtmlMessage({ className: classNameProp, ...props }, ref) {
		const { message } =
			useMessageContext<
				IChatCommandWidgetMessage<IChatCommandWidgetHtmlData>
			>();
		const messageClassName = useBlockMessageClassNames();

		return (
			<Message
				{...props}
				ref={ref}
				message={message}
				className={classNames(
					classNameProp,
					messageClassName,
					'message--command',
				)}
			>
				<Html />
			</Message>
		);
	},
);
